<template>
  <v-card width="400" class="mx-auto mt-12">
    <v-card-title>
      Numero di notifiche per servizio
    </v-card-title>
    <v-card-text>
      <v-select
        v-bind:value="periodFilter"
        v-on:input="applyPeriodFilter"
        v-bind:items="dateIntervals"
        v-bind:loading="server_loading"
        label="Periodo"
        clearable
      />

      <v-simple-table>
        <template v-slot:default>
          <tbody>
            <tr
              v-for="item in rows"
              v-bind:key="item.service_id"
              v-on:click="loadNotificationsByServiceAndPeriod(item.service_id)"
            >
              <td>{{ item.service }}</td>
              <td class="text-right">{{ item.count }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-card-actions>
      <v-btn class="primary" v-on:click="loadRows" block>Aggiorna</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import server from '../mixins/server'
import period from '../mixins/period'

export default {
  name: 'Home',

  mixins: [ server, period ],

  data: () => ({
    rows: [],
    periodFilter: null,
    periodDates: null,
    dateIntervals: [],
  }),

  mounted: function() {
    this.dateIntervals = this.period_list;
    this.applyPeriodFilter('30d');
  },

  methods: {
    applyPeriodFilter: function(value) {
      this.periodFilter = value;
      this.loadRows();
    },

    loadRows: function() {
      const parameters = {};

      this.periodFilter &&
      (this.periodDates = this.period_toDateInterval(this.periodFilter)) &&
      ([parameters.from, parameters.to] = this.periodDates);

      this.server_query({
        url: 'Notification/countByService',
        parameters: parameters,
        onSuccess: (data) => { this.rows = data; },
      });
    },

    loadNotificationsByServiceAndPeriod: function(serviceId) {
      this.$router.push({
        name: 'notifications_filtered',
        params: {
          serviceId: serviceId,
          period: this.periodFilter,
        }
      });
    },
  }
}
</script>